import React from 'react'
import { isEmpty, isNil } from 'lodash'
import { FloatingPortal, FloatingFocusManager, FloatingArrow } from '@floating-ui/react'

import { SearchableDropdownResults } from '../../dropdowns/SearchableDropdownResults'
import {
  useSearchableDropdown,
  useDropdownFloating,
  focusDropdownTrigger,
} from '../../dropdowns/dropdowns.helpers'
import { FilterPill } from '../FilterPill'

export const FilterTypeSearchableDropdown = ({
  schema = {},
  value,
  loading,
  updateSearch,
  hideSearch,
  placement = 'bottom-start',
  isClearable = false,
  isMultiSelect = false,
  showResultsHeader = false,
  selectedOptionFirst = true,
  pinnedAccessor = 'is_favorite',
  actions,
  handleCreate = null,
  inputProps = {},
  dataTestId,
}) => {
  const {
    refs,
    floatingStyles,
    getReferenceProps,
    getFloatingProps,
    context,
    open,
    setOpen,
    arrowRef,
  } = useDropdownFloating({ placement, withArrow: true })

  const options = schema.options || []
  const { sortedOptions, emptyValue, isNestedSelect, selectedLabel, normalizedSelected } =
    useSearchableDropdown({
      options,
      selected: value,
      isMultiSelect,
      selectedOptionFirst,
      pinnedAccessor,
      buttonLabel: schema.label,
      countLabel: schema.label,
      handleCreate,
    })
  const hasSelection = isMultiSelect ? !isEmpty(value) : !isNil(value)

  const handleSelect = (selectedValue, updatedValues) => {
    if (isMultiSelect) {
      updateSearch(schema.accessor, updatedValues)
    } else {
      updateSearch(schema.accessor, selectedValue)
    }
  }

  return (
    <>
      <div
        ref={refs.setReference}
        {...getReferenceProps()}
        tabIndex={-1}
        className="searchable-dropdown-trigger"
      >
        <FilterPill
          clickable
          isClearable={isClearable && hasSelection}
          handleRemoveFilter={(event) => {
            event.stopPropagation()

            updateSearch(schema.accessor, emptyValue)
            setOpen(false)
          }}
          loading={loading}
          label={schema.label}
          value={hasSelection ? selectedLabel : ''}
          active={open}
          dataTestId={dataTestId}
        />
      </div>
      {open && (
        <FloatingPortal>
          <FloatingFocusManager context={context} modal={false} initialFocus={-1}>
            <div
              ref={refs.setFloating}
              className="searchable-dropdown-floating"
              style={floatingStyles}
              {...getFloatingProps()}
            >
              <SearchableDropdownResults
                arrow={
                  <FloatingArrow
                    ref={arrowRef}
                    context={context}
                    fill="var(--color-background-surface)"
                    stroke="var(--color-border)"
                    strokeWidth={1}
                  />
                }
                hideSearch={hideSearch}
                options={sortedOptions}
                setOpen={setOpen}
                handleSelect={(...args) => {
                  handleSelect(...args)

                  if (!isMultiSelect) {
                    setOpen(false)
                    focusDropdownTrigger(refs.domReference.current)
                  }
                }}
                loading={loading}
                inputProps={inputProps}
                selected={normalizedSelected}
                actions={actions}
                pinnedAccessor={pinnedAccessor}
                showResultsHeader={showResultsHeader}
                handleCreate={handleCreate}
                isMultiSelect={isMultiSelect}
                emptyValue={emptyValue}
                isNestedSelect={isNestedSelect}
                isClearable={isClearable}
              />
            </div>
          </FloatingFocusManager>
        </FloatingPortal>
      )}
    </>
  )
}
